import { SET_ACTIVATECATEGORY } from '../actions';

const categoryactive = (state = [], action) => {
  switch (action.type) {
	case SET_ACTIVATECATEGORY:
      return [...action.value];  
    default: return state;
  }
}

export default categoryactive;
